export const GRID_METRIC_REGISTRY = [
  // ── Fuel & Consumption ──────────────────────────────────────────────────
  {
    id: "worst_mpg_vehicles",
    labelKey: "metric_worst_mpg_vehicles",
    label: "Fuel Consumption Rate – Vehicle Ranked",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "efficiency", decimals: 2 },
  },
  {
    id: "worst_mpg_drivers",
    labelKey: "metric_worst_mpg_drivers",
    label: "Fuel Consumption Rate – Driver Ranked",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "efficiency", decimals: 2 },
  },
  {
    id: "fuel_cost_trend",
    labelKey: "metric_fuel_cost_trend",
    label: "Fuel Cost",
    domain: "fuel",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "highest_spend_vehicles",
    labelKey: "metric_highest_spend_vehicles",
    label: "Fuel Cost per Vehicle",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "highest_spend_drivers",
    labelKey: "metric_highest_spend_drivers",
    label: "Fuel Cost per Driver",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "fuel_quantity_trend",
    labelKey: "metric_fuel_quantity_trend",
    label: "Fuel Consumption – Quantity",
    domain: "fuel",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "volume", decimals: 2 },
  },
  {
    id: "fillup_count_vehicles",
    labelKey: "metric_fillup_count_vehicles",
    label: "Fuel Fill-Up Count – Vehicle",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "count" },
  },
  {
    id: "fillup_count_drivers",
    labelKey: "metric_fillup_count_drivers",
    label: "Fuel Fill-Up Count – Driver",
    domain: "fuel",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "count" },
  },

  // ── Vehicle Utilization ─────────────────────────────────────────────────
  {
    id: "current_odometer_vehicles",
    labelKey: "metric_current_odometer_vehicles",
    label: "Current Odometer – Vehicle",
    domain: "utilization",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "odometer", decimals: 2 },
  },
  {
    id: "oldest_vehicles",
    labelKey: "metric_oldest_vehicles",
    label: "Vehicle Age – Years",
    domain: "utilization",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "number", decimals: 0, unit: "yrs" },
  },
  {
    id: "vehicle_utilization_rate_trend",
    labelKey: "metric_vehicle_utilization_rate_trend",
    label: "Utilization Rate per Day – Vehicle",
    domain: "utilization",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "driver_utilization_rate_trend",
    labelKey: "metric_driver_utilization_rate_trend",
    label: "Utilization Rate per Day – Driver",
    domain: "utilization",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "percent", decimals: 2 },
  },

  // ── Total Cost of Ownership ─────────────────────────────────────────────
  {
    id: "lifetime_fleet_tco_trend",
    labelKey: "metric_lifetime_fleet_tco_trend",
    label: "Lifetime Fleet TCO – Vehicle",
    domain: "tco",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "highest_tco_vehicles",
    labelKey: "metric_highest_tco_vehicles",
    label: "Cumulative TCO per Vehicle",
    domain: "tco",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "worst_tco_per_mile_vehicles",
    labelKey: "metric_worst_tco_per_mile_vehicles",
    label: "TCO per Unit of Utilization",
    domain: "tco",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "currency_per_distance", decimals: 2 },
  },

  // ── Operating Costs ─────────────────────────────────────────────
  {
    id: "operating_cost_trend",
    labelKey: "metric_operating_cost_trend",
    label: "Operating Cost",
    domain: "oc",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "worst_operating_cost_per_mile",
    labelKey: "metric_worst_operating_cost_per_mile",
    label: "Operating Cost per Mile",
    domain: "oc",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "currency_per_distance", decimals: 2 },
  },

  // ── Work Order Data ─────────────────────────────────────────────────────
  {
    id: "percent_vehicles_down_trend",
    labelKey: "metric_percent_vehicles_down_trend",
    label: "% Vehicles Down",
    domain: "workorders",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "wo_open_count_trend",
    labelKey: "metric_wo_open_count_trend",
    label: "Current WO Open Count",
    domain: "workorders",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "count" },
  },
  {
    id: "percent_scheduled_wos_trend",
    labelKey: "metric_percent_scheduled_wos_trend",
    label: "% Scheduled WOs",
    domain: "workorders",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "percent", decimals: 2 },
  },
  {
    id: "avg_cost_per_wo_trend",
    labelKey: "metric_avg_cost_per_wo_trend",
    label: "Total WO Cost",
    domain: "workorders",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "currency", decimals: 2 },
  },
  {
    id: "cumulative_wo_count",
    labelKey: "metric_cumulative_wo_count",
    label: "Cumulative WO Count",
    domain: "workorders",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "count" },
  },
  {
    id: "wos_per_vehicle_per_month",
    labelKey: "metric_wos_per_vehicle_per_month",
    label: "WOs per Vehicle per Month",
    domain: "workorders",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "number", decimals: 0 },
  },
  {
    id: "labor_hours_per_technician",
    labelKey: "metric_labor_hours_per_technician",
    label: "Labor Hours per Technician",
    domain: "workorders",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "number", decimals: 2, unit: "hrs" },
  },
  {
    id: "repair_reason_breakdown",
    labelKey: "metric_repair_reason_breakdown",
    label: "Reason for Repair(RFR)",
    domain: "workorders",
    chartType: "pie",
    colSpan: 1,
    labelMapKey: "repairReason",
  },

  // ── Inspections & Downtime ───────────────────────────────────────────
  {
    id: "vehicles_not_inspected_trend",
    labelKey: "metric_vehicles_not_inspected_trend",
    label: "Vehicles Not Inspected",
    domain: "inspections",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "count" },
  },
  {
    id: "vehicles_down_per_day",
    labelKey: "metric_vehicles_down_per_day",
    label: "Number of Vehicles Down",
    domain: "inspections",
    chartType: "timeSeries",
    colSpan: 1,
    valueFormat: { type: "count" },
  },
  {
    id: "downtime_hours_per_vehicle",
    labelKey: "metric_downtime_hours_per_vehicle",
    label: "Downtime Hours per Vehicle",
    domain: "inspections",
    chartType: "rankedBar",
    colSpan: 1,
    valueFormat: { type: "number", decimals: 2, unit: "hrs" },
  },
];

// Pre-selected defaults matching the wireframe's visible grid widgets
export const DEFAULT_GRID_IDS = [
  "worst_mpg_vehicles",
  "fuel_cost_trend",
  "highest_spend_vehicles",
  "fillup_count_vehicles",
  "current_odometer_vehicles",
  "oldest_vehicles",
  "highest_tco_vehicles",
  "operating_cost_trend",
  "worst_operating_cost_per_mile"
];
